import { useOkapiKy } from '@folio/stripes-core';
import { useQuery } from 'react-query';

const LANGUAGES_API = 'languages';

/**
 * Fetches active languages from GET /languages
 * Used to populate the Locale filter options.
 */
export function useLanguages({ enabled = true } = {}) {
  const ky = useOkapiKy();

  return useQuery(
    [LANGUAGES_API],
    () =>
      ky
        .get(LANGUAGES_API, {
          searchParams: {
            query: 'status=="active" sortby name',
            limit: 1000,
          },
        })
        .json(),
    {
      enabled,
      staleTime: 300_000, // 5 minutes — languages rarely change
    },
  );
}
